import React from 'react';
import * as ds from './dataService';
import {
  StyledPhotoUploadField,
  StyledTextField
} from 'modules/components/layer01';
import { FormBaseLayout } from 'modules/components/layer10';
import _ from 'lodash';
import {
  Box,
  Stack
} from '@mui/material';


export type SavePersonFormProps = {
  id: string;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: SavePersonFormProps) => {
  const form = ds.useFormState();
  const [
    fnSavePerson,
    { loading }
  ] = ds.useSavePerson();

  const handleSubmit = async () => {
    const tempInput = form.formState;
    _.unset(tempInput, 'profileApiFileUrl');
    const input = {
      ...tempInput
    };
    await fnSavePerson(input);
    props.handleClose();
  };
  const fields: (keyof typeof form.formState)[] = [
    'firstName',
    'lastName',
    'phoneNumber',
    'preferredEmail'
  ];

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={async () => {
        await handleSubmit();
      }}
      isLoading={loading}
      cancelButtonText='Cancel'
      successButtonText='Save'
    >
      <Stack
        columnGap='2rem'
      >
        <StyledPhotoUploadField.FC
          form={form}
          formFieldPropertyName='apiFileId'
          formLabel='Profile Picture'
          formFieldUrlPropertyName='profileApiFileUrl'
        >
          <Box
            sx={{
              maxWidth: '20rem'
            }}
            margin='auto'
            component='img'
            src={form.formState.profileApiFileUrl}
          />
        </StyledPhotoUploadField.FC>


        {
          fields.map((node, i) => (
            <StyledTextField.FC
              key={i}
              {...form.genFieldProps(node)}
            />
          ))
        }
      </Stack>

      {/* ADD FIELDS */}
    </FormBaseLayout.FC>
  );
};
